import { Animation } from '@ionic/core';
import { tooltipOpenAnimation } from './open';

export function tooltipCloseAnimation(element: HTMLElement): Animation {
  return tooltipOpenAnimation(element).direction('reverse');
}
